export default window.i18n;
